import { FC } from 'react'
import { useAppSelector } from '../../hooks/useStore'

import SubMenuList from './SubMenuList'
// Types
import { SubMenu } from '../../constants/type/menu'
import MenuListItem from './MenuListItem'
import { MenuListProps } from '../types'

type IProps = MenuListProps & {
  subMenuData?: SubMenu[]
}

const MenuList: FC<IProps> = ({ id, hasSubMenu, Icon, title, subMenuData }) => {
  const { isToggle, selectedMenu } = useAppSelector((state) => state.dashboardUi.sidebar)

  return (
    <div>
      {/* Menu list */}
      <MenuListItem id={id} hasSubMenu={hasSubMenu} Icon={Icon} title={title ?? ''} />
      {/* Sub menu */}
      {hasSubMenu && (
        <SubMenuList
          data={subMenuData as SubMenu[]}
          isToggle={isToggle}
          menuId={id}
          selectedMenu={selectedMenu}
        />
      )}
    </div>
  )
}

export default MenuList
